import { Scope } from '@bingads-webui-react/with-site-map';

export const externalMap = [
  {
    id: 'import-google',
    source: 'import',
    scope: [Scope.Account],
    route: 'googleimport',
    oldUIBaseRoute: '/Campaign/ImportCampaign/GoogleImport',
  },
  {
    id: 'import-file',
    source: 'import',
    scope: [Scope.Account],
    route: 'fileimport',
    oldUIBaseRoute: '/Campaign/ImportCampaign/FileImport',
  },
  {
    id: 'import-schedule',
    source: 'campaign', // The processor will treat this like a campaign site
    scope: [Scope.Account],
    route: 'importschedule',
    oldUIRoute: 'importschedule',
  },
  {
    id: 'dimensions',
    source: 'campaign',
    scope: [Scope.Account],
    oldUIRoute: 'dimensions',
  },
  {
    id: 'standard-reports',
    source: 'reporting',
    scope: [],
    oldUIBaseRoute: '/Reporting',
  },
  {
    id: 'report-history',
    source: 'reporting',
    scope: [],
    oldUIBaseRoute: '/Reporting',
  },
  {
    id: 'billing-payments',
    route: 'billingpayments',
    source: 'cc',
    scope: [Scope.Account],
    oldUIBaseRoute: '/cc/Billing',
  },
  {
    id: 'account-access',
    route: 'accountaccess',
    source: 'cc',
    scope: [Scope.Account],
    oldUIBaseRoute: '/cc/Users',
  },
  {
    id: 'linked-accounts',
    route: 'linkedaccounts',
    source: 'cc',
    scope: [],
    oldUIBaseRoute: '/cc/accounts',
  },
  {
    id: 'preferences',
    route: 'preferences',
    source: 'cc',
    scope: [],
    oldUIBaseRoute: '/cc/Settings',
    oldUIHashRoute: 'mysettings',
  },
  {
    id: 'my-settings',
    route: 'my-settings',
    source: 'cc',
    scope: [],
    oldUIBaseRoute: '/cc/Settings',
  },
  {
    id: 'keyword-planner',
    route: 'keywordplanner',
    source: 'ai',
    scope: [Scope.Account],
    oldUIBaseRoute: '/Research/KeywordPlanner',
    oldUIHashRoute: 'start',
  },
  {
    id: 'ad-preview',
    route: 'adpreview',
    scope: [Scope.Account],
    oldUIBaseRoute: '/Tools/AdPreview',
  },
  {
    id: 'audience-planner',
    route: 'audienceplanner',
    scope: [Scope.Account],
    oldUIBaseRoute: '/Campaign/AudienceDashboard',
  },
  {
    id: 'accounts-summary',
    route: 'accountssummary',
    oldUIBaseRoute: '/Campaign/AccountsSummary',
    scope: [Scope.Account],
  },
  {
    id: 'performance',
    route: 'accounts/performance',
    source: 'accounts-summary',
    oldUIRoute: 'accounts-summary/performance',
    scope: [],
  },
  {
    id: 'management',
    route: 'accounts/management',
    source: 'accounts-summary',
    oldUIRoute: 'accounts-summary/budget',
    scope: [],
  },
  {
    id: 'requests',
    route: 'accounts/requests',
    source: 'accounts-summary',
    oldUIRoute: 'accounts-summary/requests',
    scope: [],
  },
  {
    id: 'notifications',
    route: 'accounts/notifications',
    source: 'accounts-summary',
    oldUIRoute: 'accounts-summary/notification',
    scope: [],
  },
  {
    id: 'import',
    route: 'accounts/import',
    source: 'accounts-summary',
    oldUIRoute: 'accounts-summary/import',
    scope: [],
  },
  {
    id: 'bulk-operations',
    source: 'accounts-summary',
    oldUIRoute: 'bulk-operations',
    scope: [],
  },
  {
    id: 'build-spreadsheet',
    source: 'accounts-summary',
    oldUIRoute: 'bulk-operations/build-spreadsheet',
    scope: [],
  },
  {
    id: 'bulk-uploads',
    source: 'accounts-summary',
    oldUIRoute: 'bulk-operations/uploads',
    scope: [],
  },
  {
    id: 'saved-account-reports',
    source: 'accounts-summary',
    oldUIRoute: 'reports',
    scope: [],
  },
  {
    id: 'hotel-center',
    route: 'hotelcenter',
    oldUIBaseRoute: '/Campaign/HotelCenter',
  },
  {
    id: 'create-account-obo',
    route: 'customers/createcustomer',
    source: 'cc',
    scope: [],
    oldUIBaseRoute: '/cc/customers/createcustomer',
  },
  {
    id: 'account-create',
    route: 'account-create',
    source: 'cc',
    scope: [],
    oldUIBaseRoute: '/cc/Account/Create',
  },
  {
    id: 'account-linking',
    route: 'account-linking',
    source: 'cc',
    scope: [],
    oldUIBaseRoute: '/cc/Agency/SendInvite',
  },
  {
    id: 'insertion-order',
    route: 'insertion-order',
    source: 'cc',
    scope: [],
    oldUIBaseRoute: '/cc/InsertionOrder',
  },
  {
    id: 'payment-methods',
    route: 'payment-methods',
    source: 'cc',
    scope: [],
    oldUIBaseRoute: '/cc/PaymentMethods',
  },
  {
    id: 'credit-hold',
    route: 'CreditHold/Dashboard',
    source: 'cc',
    scope: [],
    oldUIBaseRoute: '/cc/CreditHold/Dashboard',
  },
  {
    id: 'smart-campaigns',
    route: 'smartcampaigns',
    source: 'smart',
    scope: [Scope.Account],
    oldUIBaseRoute: '/Campaign/Smart',
    oldUIHashRoute: '/',
  },
];
